import React from 'react'
import Header from '../../headerone/Main'
import { Breadcrumb } from 'react-bootstrap'
import { Link } from 'react-router-dom';

function Main() {
    return (
        <>
            <Header />
            <Breadcrumb title='test' subtitle="testing" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">
                        <div className="row">
                            <div className="col-lg-5 col-md-12 col-sm-12">
                                <div className="team-img-box">
                                    <Link to="/team-single">
                                        <img src="https://files.iittp.ac.in/images/demo/iit/Dr.Rajesh.jpg" alt="img" />
                                    </Link>
                                </div>
                            </div>
                            <div className="text-column col-lg-7 col-md-12 col-sm-12">
                                <div className="s-about-content pl-30 wow fadeInRight" data-animation="fadeInRight" data-delay=".2s" >
                                    <h2>Dr. S.Rajesh </h2>
                                    <p>Assistant Professor</p>
                                    <div className="per-info">
                                        <div className="info-text">
                                            <strong>Department</strong>
                                            <p><Link to="people/faculty/mathematics-department">Mathematics Home</Link></p>
                                        </div>
                                        <div className="info-text">
                                            <strong>Personal Webpage</strong>
                                            <p><i className="fal fa-globe" /><Link to="#">Link</Link></p>
                                        </div>
                                        <div className="info-text">
                                            <p>
                                                <i className="fal fa-phone" />  0877 2503359
                                            </p>
                                            <p>
                                                <i className="fal fa-envelope" />srajesh@iittp.ac.in
                                            </p>
                                        </div>
                                    </div>
                                    <div className='text-dark'>

                                        <h3 className='c-headline'>Areas of Interest </h3>                               
                                        <ul className='ms-3' >
                                                 <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Metric Fixed Point Theory</li>
                                            </ul>  

                                        <h3 className='c-headline'>Education</h3>
                                        <ul className='ms-3' >
                                            <li><i className="fal fa-arrow-alt-circle-right  me-3 c-link" />Ph.D, IIT Madras, India </li>
                                        </ul>

                                        <h3 className='c-headline'>Latest Publications</h3>
                                            <ul className='ms-3' >
                                                  <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />S. Rajesh and P. Veeramani. Lim's center and fixed point theorems for isometry mappings. To appear in  Annals of Functional Analysis</li>
                                                  <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />S. Rajesh. On existence of fixed points for pointwise eventually nonexpansive mappings. To appear in Journal of Fixed Point Theory and Applications (DOI: 10.1007/s11784-017-0403-7). </li>
                                                  <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />S. Rajesh and P. Veeramani. Best Proximity Point Theorems for Asymptotically Relatively Nonexpansive Mappings. Numerical Functional Analysis and Optimization Vol.37 (2016),80-91. (http://dx.doi.org/10.1080/01630563.2015.1079533)</li>
                                                  <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />S. Rajesh and P. Veeramani. Chebyshev Centers, Best Proximity Point Theorems and Fixed Point Theorems. Acta Scientiarum Mathematicarum (Szeged)}, Vol. 82 (2016), 289—304 (doi: 10.14232/actasm-014-833-1).</li>
                                                  <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />S. Rajesh and P. Veeramani. Chebyshev centers and fixed point theorems.   Journal of Mathematical Analysis and Applications, Vol 422 (2015), no. 2, 880--885 (http://dx.doi.org/10.1016/j.jmaa.2014.09.009). </li>
                                            </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Main;